/**
 * CC DCRP API
 * Connected Claims Damaged Container Recovery API's.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { LiablePartyTypeDTO } from '../models/liablePartyTypeDTO';
import { StringResponse } from '../models/stringResponse';
import { LiablePartyTypeDTOIEnumerableResponse } from '../models/liablePartyTypeDTOIEnumerableResponse';

@Injectable()
export class LiablePartyTypeService {
  protected basePath = environment.dcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * Delete liable party by PartyTypeId.  Note: PartyTypeId is NOT the Id(Identity).
   * Sample request:                    DELETE PartyTypeId                Returns string: True for success or failure reason.
   * @param partyTypeId
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public liablePartyTypeDelete(
    partyTypeId: number,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<StringResponse>;
  public liablePartyTypeDelete(
    partyTypeId: number,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<StringResponse>>;
  public liablePartyTypeDelete(
    partyTypeId: number,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<StringResponse>>;
  public liablePartyTypeDelete(
    partyTypeId: number,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (partyTypeId === null || partyTypeId === undefined) {
      throw new Error(
        'Required parameter partyTypeId was null or undefined when calling liablePartyTypeDelete.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (partyTypeId !== undefined && partyTypeId !== null) {
      queryParameters = queryParameters.set('PartyTypeId', <any>partyTypeId);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<StringResponse>(
      'delete',
      `${this.basePath}/liable-party-type`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Returns all the liable party types.
   *  Sample request:         GET All    Returns all liable party types as, IEnumerable of LiablePartyTypeDTO
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public liablePartyTypeGet(
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<LiablePartyTypeDTOIEnumerableResponse>;
  public liablePartyTypeGet(
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<LiablePartyTypeDTOIEnumerableResponse>>;
  public liablePartyTypeGet(
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<LiablePartyTypeDTOIEnumerableResponse>>;
  public liablePartyTypeGet(
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<LiablePartyTypeDTOIEnumerableResponse>(
      'get',
      `${this.basePath}/liable-party-type`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Create new liable party type. Note: GCSSPartyType can be shipment (lower), tpdoc (lower) or null.
   * Sample request:                    POST liablePartyTypeDTO                Returns string: True for success or failure reason.
   * @param body
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public liablePartyTypePost(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<StringResponse>;
  public liablePartyTypePost(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<StringResponse>>;
  public liablePartyTypePost(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<StringResponse>>;
  public liablePartyTypePost(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling liablePartyTypePost.'
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<StringResponse>(
      'post',
      `${this.basePath}/liable-party-type`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Update liable party type. Note: GCSSPartyType can be shipment (lower), tpdoc (lower) or null.
   * Sample request:                    PUT liablePartyTypeDTO                Returns string: True for success or failure reason.
   * @param body
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public liablePartyTypePut(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<StringResponse>;
  public liablePartyTypePut(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<StringResponse>>;
  public liablePartyTypePut(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<StringResponse>>;
  public liablePartyTypePut(
    body: LiablePartyTypeDTO,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling liablePartyTypePut.'
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<StringResponse>(
      'put',
      `${this.basePath}/liable-party-type`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
